import {Icon, IconsCloudsArray} from '../model/icon';

export function findIconByAlt(altName: string): Icon | undefined {
  return IconsCloudsArray.find(icon => icon.alt === altName);
}

export function findIconByCss(css: string, type: string, index: number): Icon | undefined {
  const regex = new RegExp(`${type}${index}:\\s*([^;]+)`, 'i');
  const match = css.match(regex);
  if (match === null) {
    return undefined;
  }
  const altValue = match[1].trim();
  return findIconByAlt(altValue);
}

export function findTextByCss(css: string, type: string, index?: number): string | undefined {
  let regex;
  if (index === undefined) {
    regex = new RegExp(`${type}:\\s*([^;]+)`);
  } else {
    regex = new RegExp(`${type + index}:\\s*([^;]+)`);
  }
  const match = css.match(regex);
  if (match === null) {
    return undefined;
  }
  const value = match[1].trim();
  return value !== '' ? value : undefined;
}

